import React, { useRef } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const imgQuery = graphql`
  query {
    file(relativePath: { eq: "brown-wooden-vase-near-the-window.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default () => {
  const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9]
  const data = useStaticQuery(imgQuery)
  return (
    <div className="flex flex-col mt-4" style={{ backgroundColor: "#E6F4F2" }}>
      <div className="flex flex-col items-center mb-8">
        <div className="w-full flex items-center px-1 md:px-20 my-6">
          <span className="text-3xl font-bold inline-block">
            &mdash; Soyez inspirés !
          </span>
          {/* <span className="ml-auto text-right">
            Toutes nos planches tandances
          </span> */}
        </div>
        <div className="flex flex-col md:flex-row items-center">
          <div className="relative inline-block">
            <Img className="w-64" fluid={data.file.childImageSharp.fluid} />
            <div className="absolute top-0 left-0 bg-orange-300 w-full h-full opacity-50"></div>
          </div>
          <div className="z-10 inline-block">
            <p className="mx-3 md:-mx-10 text-3xl">
              Envoie d'un <br /> intérieur ARTY ?
            </p>
            <p className="mx-3 md:-mx-10 text-3xl mb-8">Adjugé!</p>
            <p className="mx-3 w-64">
              Osez un pétillant clin d'oeil à la mode et à la déco des années 50
              à 70. Notre style ARTY, est chaud, chaud...
            </p>
          </div>
        </div>
      </div>

      {/* <div className="flex flex-wrap items-center px-6 pb-6 -mx-2">
        {arr.map(i => {
          return (
            <div
              key={i}
              className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 px-2"
            >
              <img
                src="https://via.placeholder.com/350x500"
                className="rounded mt-4 align-middle w-full"
                alt=""
              />
              <div className="flex flex-col">
                <span className="block text-sm px-2">-Rideaux et voilages</span>
                <span className="block">Rideaux pour filtrer le soleil</span>
              </div>
            </div>
          )
        })}
      </div> */}
    </div>
  )
}
